import React, { Component } from "react";
import SiteConfig from "../../config/SiteConfig.json";
import { CategoryIcons } from "../../utils/Category-Icons";
import _ from "lodash";
import {
  Nav,
  NavItem,
  NavLink,
  Navbar,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  ListGroup,
  Row,
  Col,
} from "reactstrap";
import { navigate, Link, withPrefix } from "gatsby";
import classnames from "classnames";

class CategoryTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "",
      posts: "",
      categoryIndex: "",
      leftSide: "",
      rightSide: "",
      postsLength: "",
    };
  }

  componentDidMount() {
    let { json, category, lang } = this.props;
    let posts;
    for (let i in json) {
      if (json[i].category === category && lang === "en") {
        posts = json[i].posts;
        if (posts.length >= 10) {
          let half_length = Math.floor(posts.length / 2);
          let arrayFirstHalf = posts.slice(0, half_length);
          let arraySecondHalf = posts.slice(half_length, posts.length);
          this.setState({
            activeTab: category,
            posts: posts,
            categoryIndex: i,
            leftSide: arrayFirstHalf,
            rightSide: arraySecondHalf,
            postsLength: posts.length,
          });
        } else {
          this.setState({
            activeTab: category,
            posts: posts,
            categoryIndex: i,
            postsLength: posts.length,
          });
        }

        break;
      } else if (json[i].translatedCategory === category && lang !== "en") {
        posts = json[i].posts;
        if (posts.length >= 10) {
          let half_length = Math.floor(posts.length / 2);
          let arrayFirstHalf = posts.slice(0, half_length);
          let arraySecondHalf = posts.slice(half_length, posts.length);
          this.setState({
            activeTab: json[i].translatedCategory,
            posts: posts,
            categoryIndex: i,
            leftSide: arrayFirstHalf,
            rightSide: arraySecondHalf,
            postsLength: posts.length,
          });
        } else {
          this.setState({
            activeTab: json[i].translatedCategory,
            posts: posts,
            categoryIndex: i,
            postsLength: posts.length,
          });
        }

        break;
      }
    }
  }

  toggle = (category, posts, categoryMeta, index) => {
    let { activeTab } = this.state;
    if (activeTab !== category) {
      this.setState({
        activeTab: category,
        posts: posts,
        categoryIndex: index,
      });
    }
    navigate(categoryMeta);
  };

  render() {
    //used to add fake scroll
    window.scrollTo({
      top: 123,
      behavior: "smooth",
    });

    const pathLocation = window.location.toString().includes("category");
    
    let { json, lang, showPosts, deviceTipsListItem, tutorialListItem } =
      this.props;
    let { activeTab, posts, categoryIndex, leftSide, rightSide, postsLength } =
      this.state;
    
    if (pathLocation) {
      return (
        <div className="bm_tabs_wrapper" style={{ paddingTop: "20px" }}>
          <Container style={{ padding: "0 10px 40px 10px" }}>
            <div className="bm_tabs_desktop">
              <Nav
                style={{
                  margin: "0px auto",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {json.map((jsonPost, i) => {
                  
                  let categoryMeta;
                  if (lang !== "en") {
                    categoryMeta = `/${lang}/category/${_.toLower(
                      jsonPost.category
                    )
                      .split(" ")
                      .join("-")}`;
                  } else {
                    categoryMeta = `/category/${_.toLower(jsonPost.category)
                      .split(" ")
                      .join("-")}`;
                  }
                  return (
                    <NavItem key={`${lang}-${jsonPost.category}`}>
                      <NavLink
                        className={classnames({
                          active:
                            activeTab === jsonPost.category ||
                            activeTab === jsonPost.translatedCategory,
                        })}
                        onClick={() =>
                          this.toggle(
                            lang === "en"
                              ? jsonPost.category
                              : jsonPost.translatedCategory,
                            jsonPost.posts,
                            categoryMeta,
                            i
                          )
                        }
                        style={{ color: "#fff" }}
                      >
                        <div>
                          {`${
                            jsonPost.translatedCategory
                              ? _.replace(
                                  _.replace(
                                    jsonPost.translatedCategory,
                                    /@brand/g,
                                    SiteConfig.brand
                                  ),
                                  "Amp",
                                  "&"
                                )
                              : _.replace(
                                  _.replace(
                                    jsonPost.category,
                                    /@brand/g,
                                    SiteConfig.brand
                                  ),
                                  "Amp",
                                  "&"
                                )
                          }`}
                        </div>
                      </NavLink>
                    </NavItem>
                  );
                })}
              </Nav>
            </div>

            <div className="bm_tabs_mobile">
              <Navbar
                light
                expand="md"
                style={{ background: "rgba(0, 0, 0, 0.03)" }}
              >
                <UncontrolledDropdown setActiveFromChild>
                  <DropdownToggle
                    tag="a"
                    className="nav-link"
                    caret
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      color: "#000",
                      fontWeight: "bold",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "bold",
                      }}
                    >
                      {categoryIndex && (
                        <img
                          src={withPrefix(
                            CategoryIcons[json[categoryIndex].category]
                          )}
                          alt={activeTab}
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                      )}
                      {activeTab ? activeTab.replace("Amp", "&") : ""}
                    </div>
                  </DropdownToggle>
                  <DropdownMenu>
                    {json.map((jsonPost, i) => {
                      let categoryMeta;
                      // let category;
                      if (lang !== "en") {
                        categoryMeta = `/${lang}/category/${_.toLower(
                          jsonPost.category
                        )
                          .split(" ")
                          .join("-")}`;
                      } else {
                        categoryMeta = `/category/${_.toLower(jsonPost.category)
                          .split(" ")
                          .join("-")}`;
                      }
                      {
                        categoryIndex && (
                          <img
                            src={withPrefix(
                              CategoryIcons[json[categoryIndex].category]
                            )}
                            alt={activeTab}
                            style={{ width: "33px", height: "33px" }}
                          />
                        );
                      }
                      return (
                        <DropdownItem
                          className={classnames({
                            active: activeTab === jsonPost.category,
                          })}
                          onClick={() =>
                            this.toggle(
                              jsonPost.category,
                              jsonPost.posts,
                              categoryMeta,
                              i
                            )
                          }
                          key={`${lang}-${jsonPost.category}`}
                        >
                          <NavItem>
                            <NavLink>
                              {`${
                                jsonPost.translatedCategory
                                  ? _.replace(
                                      _.replace(
                                        jsonPost.translatedCategory,
                                        /@brand/g,
                                        SiteConfig.brand
                                      ),
                                      "Amp",
                                      "&"
                                    )
                                  : _.replace(
                                      _.replace(
                                        jsonPost.category,
                                        /@brand/g,
                                        SiteConfig.brand
                                      ),
                                      "Amp",
                                      "&"
                                    )
                              }`}
                            </NavLink>
                          </NavItem>
                        </DropdownItem>
                      );
                    })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Navbar>
            </div>

            {showPosts && (
              <Container style={{ padding: "0 10px 40px 10px" }}>
                <div
                  style={{
                    maxWidth: "1006px",
                    margin: "0px auto 20px",
                    border: "1px solid #EFEFEF",
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    borderRadius: "0px 0px 10px 10px",
                  }}
                >
                  <div
                    className="title-info-content"
                    style={{
                      display: "flex",
                      alignItems: "start",
                      marginTop: "25px",
                    }}
                  >
                    {categoryIndex && (
                      <img
                        src={withPrefix(
                          CategoryIcons[json[categoryIndex].category]
                        )}
                        alt={activeTab}
                        style={{ width: "33px", height: "33px" }}
                      />
                    )}
                    <h2
                      style={{
                        padding: "0 10px",
                        fontWeight: "bold",
                        wordBreak: "break-all",
                      }}
                    >
                      {activeTab.replace("Amp", "&")}
                    </h2>
                  </div>
                  <hr className="hide-m" style={{ marginTop: "0.3rem" }} />
                  <ListGroup className="content" style={{ margin: "0 auto" }}>
                    {categoryIndex === "4" && SiteConfig.brand === "BlueMail" ? (
                      <li style={{ padding: "5px 0" }}>
                        <Link
                          to={
                            lang === "en"
                              ? "/device-tips"
                              : `/${lang}/device-tips`
                          }
                          style={{ color: "#1F6BF1" }}
                        >
                          {deviceTipsListItem}
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {postsLength < 10 &&
                    categoryIndex === "0" &&
                    SiteConfig.brand === "BlueMail" ? (
                      <li style={{ padding: "5px 0" }}>
                        <Link
                          to={lang === "en" ? "/tutorial" : `/${lang}/tutorial`}
                          style={{ color: "#1F6BF1" }}
                        >
                          {tutorialListItem}
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}

                    {postsLength < 10 &&
                      categoryIndex &&
                      posts &&
                      posts.map((post) => {
                        if (
                          SiteConfig.brand === "BlueMail" &&
                          !_.includes(post.title, "Blix") &&
                          !_.includes(post.title, "TypeApp")
                        ) {
                          return (
                            <li key={post.meta} style={{ padding: "5px 0" }}>
                              <Link to={post.meta} style={{ color: "#1F6BF1" }}>
                                {post.title}
                              </Link>
                            </li>
                          );
                        }
                        return "";
                      })}
                    {postsLength >= 10 && categoryIndex && (
                      <Row style={{ marginRight: "0" }}>
                        <Col md="6" sm="12" className="bm_tabs_lcol_padding">
                          {categoryIndex === "0" &&
                          SiteConfig.brand === "BlueMail" ? (
                            <li style={{ padding: "5px 0" }}>
                              <Link
                                to={
                                  lang === "en"
                                    ? "/tutorial"
                                    : `/${lang}/tutorial`
                                }
                                style={{ color: "#1F6BF1" }}
                              >
                                {tutorialListItem}
                              </Link>
                            </li>
                          ) : (
                            ""
                          )}
                          {leftSide &&
                            leftSide.map((post) => {
                              if (
                                SiteConfig.brand === "BlueMail" &&
                                !_.includes(post.title, "Blix") &&
                                !_.includes(post.title, "TypeApp")
                              ) {
                                return (
                                  <li
                                    key={post.meta}
                                    style={{
                                      padding: "5px 0",
                                      lineHeight: "20px",
                                    }}
                                  >
                                    <Link
                                      to={post.meta}
                                      style={{ color: "#1F6BF1" }}
                                    >
                                      {post.title}
                                    </Link>
                                  </li>
                                );
                              }
                              return "";
                            })}
                        </Col>
                        <Col md="6" sm="12" className="bm_tabs_rcol_padding">
                          {rightSide &&
                            rightSide.map((post) => {
                              if (
                                SiteConfig.brand === "BlueMail" &&
                                !_.includes(post.title, "Blix") &&
                                !_.includes(post.title, "TypeApp")
                              ) {
                                return (
                                  <li
                                    key={post.meta}
                                    style={{
                                      padding: "5px 0",
                                      lineHeight: "20px",
                                    }}
                                  >
                                    <Link
                                      to={post.meta}
                                      style={{ color: "#1F6BF1" }}
                                    >
                                      {post.title}
                                    </Link>
                                  </li>
                                );
                              }
                              return "";
                            })}
                        </Col>
                      </Row>
                    )}
                  </ListGroup>
                </div>
              </Container>
            )}
          </Container>
        </div>
      );
    }
  }
}

export default CategoryTabs;
